import {Pages} from '@lib/constants';
import CompleteEvent from './CompleteEvent';
import Page from '@components/Pages/Page';

export const CompleteEventPage = () => {
  return (
    <Page
      title="Complete Event"
      breadcrumbs={['events', ':event', 'Complete Event']}
      sectionName="events"
      navPhoto={{ image: '/images/sessions/CREATE_EVENT_PHOTO.jpg' }}
      pageId={Pages.EVENT_COMPLETE}
      requireAuth
    >
      <CompleteEvent />
    </Page>
  )
};

export default CompleteEventPage;
